import axios from 'axios';
import { getHost } from '@/utils/utils.js';

let baseUrl = getHost();
axios.defaults.baseURL = baseUrl;
// request拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

const checkResponseCode = response => {
  return response.data;
};
// response拦截器
axios.interceptors.response.use(
  response => {
    return checkResponseCode(response);
  },
  error => {
    // 后台服务异常  404 504 请求超时等
    // window.console.err(error, error.response, error.message)
    return Promise.reject(error.response);
  }
);

export default axios;
